import { Box, Button, Paper, useMediaQuery, useTheme } from "@mui/material";

import { Add } from "@mui/icons-material";
import React, { useState } from "react";
import { DateViewMonthYear } from "../../../shared/components/DateViewMonthYear/DataViewMonthYear";

interface IToolbarReadJustProps {
	onChangeInputReference?: (text: string) => void;
	onNewReadJust?: () => void;
	canAdd?: boolean;
}

export const ToolbarReadJust: React.FC<IToolbarReadJustProps> = ({ onChangeInputReference, onNewReadJust, canAdd = true }) => {
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const [referencia, setReferencia] = useState<Date | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	const handleDateChange = (newValue: Date | null) => {
		setReferencia(newValue);
		if (newValue && onChangeInputReference) {
			// Convertendo a data para string no formato 'MM/YYYY'
			const formattedValue = `${newValue.getMonth() + 1}/${newValue.getFullYear()}`;
			onChangeInputReference(formattedValue);
		}
		//console.log(newValue);
	};

	return (
		<Box gap={1} marginX={1} paddingY={1} paddingX={2} display="flex" flexDirection={smDown ? "column" : "row"} alignItems="center" component={Paper}>
			<DateViewMonthYear title="Referência" onChange={handleDateChange} />
			<Box sx={{ display: "flex", justifyContent: "end", width: "100%", height: "100%" }}>
				<Button variant="contained" color="primary" onClick={onNewReadJust} disabled={loading || !canAdd} startIcon={<Add />}>
					Adicionar
				</Button>
			</Box>
		</Box>
	);
};
